import { api } from "../../services";

const product_categories = {
  // namespaced: true,
  state: {
    current_product_category: {
      name: null,
      user_id: null,
      channel_id: null
    },
    current_filter: {
      channel_id: null,
      department_id: null
    },
    modals: {
      new_product_category: false,
      edit_product_category: false,
    },
    pagination: [],
    data: [],
    departments_available: []
  },
  getters: {
    
  },
  mutations: {
    SET_PRODUCT_CATEGORIES(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    async getAllProductCategories(context, payload){
      await api.get("/product-categories", {
        params: payload
      }).then((response) => {
        context.commit("SET_PRODUCT_CATEGORIES", response.data);
      })
    },
    async deleteProductCategory(context, payload) {
      
      await api.delete(`/product-categories/${payload.id}`, payload).then(async () => {
        await context.dispatch("getAllProductCategories", {
          channel_id: payload.channel_id
        });
      });
    },
    async updateProductCategory(context, payload) {
      await api.put(`/product-categories/${payload.id}`, payload).then(async () => {
        await context.dispatch("getAllProductCategories", {
          channel_id: payload.channel_id
        });
      });
    },
    
    async createProductCategory(context, payload) {
      await api.post("/product-categories/", payload).then(async () => {
        await context.dispatch("getAllProductCategories", {
          channel_id: payload.channel_id
        });
      });
    }
  }
};

export default product_categories;
